module.exports = __webpack_public_path__ + "img/emd12549_XProj-min.f1be4430.jpeg";